import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { AsyncPipe, CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { Subscription } from 'rxjs';
import { formTypeActionEnum } from 'src/app/_enums/ui-development/ui-development';
import { fieldSimplified, FormDataSimplified } from 'src/app/_interfaces/formDataSimplified';
import { PipeModule } from 'src/app/_pipes/pipe.module';
import { DialogControlService } from 'src/app/_services/dialog-control.service';
import { ObjectUtilsService } from 'src/app/_services/object-utils.service';
import { PageServiceService } from 'src/app/_services/page-service.service';
import { MaterialFormModule } from 'src/app/_shared/material/material-form.module';
import { NgxTimpickerModule } from 'src/app/_shared/ngx-timpicker/ngx-timpicker.module';
import { COUNTRIES_LIST } from 'src/app/_utils/countries';
import { RoleUiEnum, RoleUiPb } from 'src/app/com/staybloom/common/uiproto/roleUiProto';
import { IdVerificationStatusUiEnum } from 'src/app/com/staybloom/profile/uiproto/verificationUiProto';
import { S3ObjectUiPb } from 'src/app/com/staybloom/s3Object/uiproto/s3ObjectUiProto';
import { CountryUiEnum } from 'src/app/com/staybloom/uiproto/address/countryUiProto';
import { AuthenticationStoreService } from 'src/app/stores/staybloom/authenticationStore/authenticationStore.services';
import { GroupedMultiselectComponent } from '../grouped-multiselect/grouped-multiselect.component';
import { MultiSelectOptionComponent } from '../multi-select-option/multi-select-option.component';
import {
  FieldTypeEnumSimplified,
  FieldWidthEnumSimplified,
} from './../../_interfaces/formDataSimplified';

export interface FieldSimplifiedWithSectionIndex {
  field: fieldSimplified;
  sectionIndex: number;
  formArrayIndex?: number;
}

@Component({
  selector: 'app-dynamic-form-landing',
  templateUrl: './dynamic-form-landing.component.html',
  styleUrls: ['./dynamic-form-landing.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'custom_select_box_overlay' },
    },
  ],
  imports: [
    CommonModule,
    MaterialFormModule,
    MatIconModule,
    GroupedMultiselectComponent,
    PipeModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    AsyncPipe,
    MatTooltipModule,
    ScrollingModule,
    MultiSelectOptionComponent,
    NgxTimpickerModule,
  ],
})
export class DynamicFormLandingComponent implements OnChanges {
  @ViewChild('formRef')
  formRef: FormGroupDirective;
  firstInvalidControl: any;
  @Input() sectionClass: string;

  @ViewChild('dynamicform') dynamicform: any;
  @Input() formSections: FormDataSimplified[];
  @Input() data: any;
  @Input() formType: string;
  @Input('showButtons') showButtons: boolean;
  formTypeActionEnum = formTypeActionEnum;
  form: FormGroup;
  FieldTypeEnumSimplified = FieldTypeEnumSimplified;
  FieldWidthEnumSimplified = FieldWidthEnumSimplified;
  @Output() dynamicFormEvent = new EventEmitter<any>();
  @Output() closeCalenderEvent = new EventEmitter<any>();
  @Output() clickEvent = new EventEmitter<any>();
  @Input('valuesToPatch') valuesToPatch: any;
  @ViewChild('virtualScroll', { static: false })
  virtualScroll!: CdkVirtualScrollViewport;

  darkTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: '#fff',
      buttonColor: '#6b6b6b',
    },
    dial: {
      dialBackgroundColor: '#ffcc09',
    },
    clockFace: {
      clockFaceBackgroundColor: '#fafafa',
      clockHandColor: '#ffcc09',
      clockFaceTimeInactiveColor: '#6b6b6b',
    },
  };
  @Output() fieldFocus = new EventEmitter<any>();
  @Output() selectionChange = new EventEmitter<any>();
  searchValue: string;
  searchCountryValue: string;
  COUNTRIES_LIST = COUNTRIES_LIST;
  @Output() fieldValueChanged = new EventEmitter<any>();
  valueChangeSubscribe: Subscription;
  userRole: RoleUiPb;
  RoleUiEnum = RoleUiEnum;
  @Output() removeFrImageEvent = new EventEmitter<any>();
  @Input() sectionEnabled: boolean = true;
  isIdentityEnabled: boolean = true;
  isSuperUser: boolean = false;
  showImageError: string = '';
  nations: any = [];
  itemSize: number = 35;
  today = new Date();
  @Input('isSectionNameLight') isSectionNameLight: boolean = false;
  unsubscribePageService: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private dialogControlService: DialogControlService,
    private objectUtils: ObjectUtilsService,
    private _pageService: PageServiceService,
    private _authenticationStoreService: AuthenticationStoreService,
  ) {
    this.unsubscribePageService = this._pageService.getCurrentHotelInventoryId().subscribe((id) => {
      this.userRole = this._authenticationStoreService.getRoleForInventory(id);
    });
    if (this.userRole?.role?.includes(RoleUiEnum.SUPER_USER)) {
      this.isSuperUser = true;
    }
    this.convertEnumForList();
  }
  ngOnChanges(changes: SimpleChanges) {
    console.log(this.formSections, 'form sections on change');
    console.log(changes, 'changes');
    const shouldPreserveValuesOnSectionChange =
      !!changes['formSections'] && !changes['formSections'].firstChange && !!this.form;
    const previousFormValues = shouldPreserveValuesOnSectionChange ? this.form.getRawValue() : null;
    // debugger;
    const shouldRebuildForm =
      !this.form ||
      !!changes['formSections'] ||
      !!changes['formType'] ||
      !!changes['sectionEnabled'];
    if (shouldRebuildForm && changes['valuesToPatch']) {
      this.formReset();
      this.patchFormValues();
      return;
    }
    if (shouldRebuildForm) {
      this.formReset();
      if (previousFormValues && this.form) {
        this.form.patchValue(previousFormValues, { emitEvent: false });
      }
      return;
    }
    console.log(this.valuesToPatch, changes, 'values to patch on change');
    if (changes['valuesToPatch']) {
      this.patchFormValues();
    }
  }

  ngOnDestroy() {
    this.valueChangeSubscribe?.unsubscribe();
    this.unsubscribePageService.unsubscribe();
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
  }

  onDrop(event: any, field: any) {
    event.preventDefault();
    event.stopPropagation();
    this.fieldValueChanged.emit(true);
    if (event.dataTransfer.files.length > 0) {
      this.selectionImageByDragAndDrop(field, event);
    }
  }

  formReset(shouldResetAll: boolean = false) {
    console.log(this.formSections);
    this.resetFields(shouldResetAll);
    this.createReactiveForm();
  }

  resetFields(shouldResetAll: boolean) {
    if (this.formSections) {
      this.formSections?.forEach((element) => {
        if (element?.fields) {
          element.fields.forEach((fieldData) => {
            if (shouldResetAll) {
              fieldData.value = '';
            } else {
              if (
                fieldData.type !== FieldTypeEnumSimplified.SELECT &&
                fieldData.type !== FieldTypeEnumSimplified.CHECKBOX
              ) {
                fieldData.value = '';
              }
            }
          });
        }
      });
      this.form = this.formBuilder.group({});
      console.log(this.formSections);
    }
  }
  getFormArrayFieldLabel(
    arrayName: string,
    fieldName: string,
    formArrayIndex: number,
    fallbackLabel: string,
  ): string {
    if (!arrayName || !fieldName || !Array.isArray(this.formSections)) {
      return fallbackLabel;
    }

    const matchingSections = this.formSections.filter(
      (section) => section?.sectionFormArray === arrayName,
    );

    const currentSection = matchingSections[formArrayIndex];
    const currentField = currentSection?.fields?.find((field) => field.name === fieldName);

    return currentField?.label || fallbackLabel;
  }
  patchFormValues() {
    if (this.valuesToPatch && Object.keys(this.valuesToPatch).length) {
      for (const section of this.formSections) {
        if (section.sectionFromGroup) {
          const sectionFormGroup = this.form.get(section.sectionFromGroup) as FormGroup;
          if (sectionFormGroup) {
            sectionFormGroup.patchValue(this.valuesToPatch[section.sectionFromGroup]);
          }
        } else if (section.sectionFormArray) {
          const formArray = this.form.get(section.sectionFormArray) as FormArray;
          const patchValues = this.valuesToPatch[section.sectionFormArray];
          if (formArray && Array.isArray(patchValues)) {
            while (formArray.length < patchValues.length) {
              formArray.push(this.createDynamicFormGroup(section.fields));
            }
            patchValues.forEach((v: any, i: number) => formArray.at(i)?.patchValue(v));
          }
        } else {
          for (const field of section.fields) {
            const control = this.form.get(field.name);
            if (control && Object.keys(this.valuesToPatch).includes(field.name)) {
              control.patchValue(this.valuesToPatch[field.name]);
            }
          }
        }
      }
    }

    this.valueChangeSubscribe?.unsubscribe();
    this.valueChangeSubscribe = this.form?.valueChanges?.subscribe((changedValue) => {
      this.fieldValueChanged.emit(changedValue);
    });
  }

  isArray(variable: any): boolean {
    return Array.isArray(variable);
  }

  /**
   * Initialize form fields - handles sectionFromGroup, sectionFormArray, and standalone fields
   */
  createReactiveForm() {
    if (this.isArray(this.formSections)) {
      const processedSectionFormArrays = new Set<string>();

      for (const section of this.formSections) {
        // Handle sectionFromGroup
        if (section?.sectionFromGroup) {
          this.initializeSectionFromGroup(section);
        }
        // Handle sectionFormArray
        else if (section?.sectionFormArray) {
          const arrayName = section.sectionFormArray;
          if (processedSectionFormArrays.has(arrayName)) {
            continue;
          }
          const totalItemsForArray = this.getSectionFormArrayCount(arrayName);
          this.initializeSectionFormArray(section, totalItemsForArray);
          processedSectionFormArrays.add(arrayName);
        }
        // Handle standalone fields
        else {
          for (const field of section.fields) {
            this.initializeFormControl(field, section);
          }
        }
      }
    }

    this.patchFormValues();
  }

  /**
   * Initialize a FormGroup for a section with sectionFromGroup
   */
  private initializeSectionFromGroup(section: FormDataSimplified): void {
    const sectionFormGroup = this.formBuilder.group({});
    let isIdentityDisabled = false;

    if (section.sectionFromGroup === 'identityDetails' && !this.sectionEnabled) {
      isIdentityDisabled = true;
      this.isIdentityEnabled = false;
    }

    // Add fields to the sectionFormGroup
    for (const field of section?.fields) {
      const validators = this.buildValidators(field);
      sectionFormGroup.addControl(
        field?.name,
        this.formBuilder.control({ value: field?.value, disabled: field?.disabled }, validators),
      );
    }

    // Disable the entire group if needed
    if (
      this.formType === formTypeActionEnum.EDITANDCHECKIN ||
      this.formType === formTypeActionEnum.EDIT ||
      section.disabled
    ) {
      sectionFormGroup.disable();
    }

    // Disable identity fields except proof documents
    if (isIdentityDisabled) {
      section.fields.forEach((element) => {
        if (element.name !== 'idProofFront' && element.name !== 'idProofBack') {
          sectionFormGroup.get(element.name)?.disable();
        }
      });
    }

    this.form.addControl(section.sectionFromGroup, sectionFormGroup);
  }

  /**
   * Initialize a FormArray for a section with sectionFormArray
   * Creates initial FormGroup and allows dynamic additions
   */

  private initializeSectionFormArray(
    section: FormDataSimplified,
    requiredLength: number = 1,
  ): void {
    if (!section?.fields || section.fields.length === 0) return;

    let formArray = this.form.get(section.sectionFormArray) as FormArray;
    if (!formArray) {
      formArray = new FormArray([]);
      this.form.setControl(section.sectionFormArray, formArray);
    }

    while (formArray.length < requiredLength) {
      formArray.push(this.createDynamicFormGroup(section.fields));
    }

    while (formArray.length > requiredLength) {
      formArray.removeAt(formArray.length - 1);
    }
  }

  private getSectionFormArrayCount(arrayName: string): number {
    if (!arrayName || !Array.isArray(this.formSections)) {
      return 1;
    }

    const count = this.formSections.filter(
      (section) => section?.sectionFormArray === arrayName,
    ).length;
    return count > 0 ? count : 1;
  }

  isFirstSectionFormArrayOccurrence(arrayName: string, index: number): boolean {
    if (!arrayName || !Array.isArray(this.formSections)) {
      return false;
    }
    return (
      this.formSections.findIndex((section) => section?.sectionFormArray === arrayName) === index
    );
  }

  /**
   * Create a FormGroup for array items with proper validators
   */
  private createDynamicFormGroup(fields: fieldSimplified[]): FormGroup {
    const group: any = {};
    let a: fieldSimplified[] = JSON.parse(JSON.stringify(fields));
    a.forEach((field) => {
      const validators = this.buildValidators(field);
      group[field.name] = this.formBuilder.control(
        { value: field?.value || '', disabled: field?.disabled },
        validators,
      );
    });
    return this.formBuilder.group(group);
  }

  /**
   * Initialize a standalone form control
   */
  private initializeFormControl(field: fieldSimplified, section: FormDataSimplified): void {
    const validators = this.buildValidators(field);
    const controlOptions = {
      value: field?.value,
      disabled:
        this.formType === formTypeActionEnum.EDITANDCHECKIN ||
        this.formType === formTypeActionEnum.EDIT ||
        field?.disabled,
    };

    if (field?.formGroup && field.fields) {
      // Nested FormGroup
      const nestedGroup = this.formBuilder.group({});
      field.fields.forEach((ele) => {
        nestedGroup.addControl(
          ele?.name,
          this.formBuilder.control(ele?.value, this.buildValidators(ele)),
        );
      });
      this.form.addControl(field.name, nestedGroup);
    } else {
      // Regular FormControl
      this.form.addControl(field?.name, this.formBuilder.control(controlOptions, validators));
    }
  }

  /**
   * Build validators array for a field
   */
  private buildValidators(field: fieldSimplified): any[] {
    const validators: any[] = [];
    if (field?.required) {
      validators.push(Validators.required);
    }
    if (field?.pattern) {
      validators.push(Validators.pattern(field.pattern));
    }
    return validators;
  }

  isTextAreaAvailable: boolean = false;

  onChangeHandler(event: any) {
    if (event.toUpperCase() === 'OTHER') {
      this.isTextAreaAvailable = true;
    } else {
      this.isTextAreaAvailable = false;
    }
  }

  onSubmit() {
    this.dynamicFormEvent.emit(this.form);
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      setTimeout(() => {
        this.scrollToFirstError();
      }, 0);
    }
    return this.form;
  }

  removeFormArrayControlAt(arrayName: string, index: number): void {
    const formArray = this.form?.get(arrayName) as any;
    if (formArray && index >= 0 && index < formArray.length) {
      formArray.removeAt(index);
    }
  }

  onFieldFocus(field: fieldSimplified, sectionIndex?: number, formArrayIndex?: number) {
    console.log('onFieldFocus', field);
    const arrayName = sectionIndex !== undefined
      ? this.formSections?.[sectionIndex]?.sectionFormArray
      : null;
    if (arrayName && formArrayIndex !== undefined) {
      const formArray = this.form.get(arrayName) as FormArray;
      field.value = formArray?.at(formArrayIndex)?.get(field.name)?.value;
    } else {
      field.value = this.form.value[field.name];
    }
    let input: FieldSimplifiedWithSectionIndex = { field, sectionIndex, formArrayIndex };
    this.fieldFocus.emit(input);
  }

  onSelectionChange(field: any, $event: any, index?: number) {
    console.log('onSelectionChange');
    console.log($event);
    console.log(field);
    if (field.type == 'file' || field?.type == 'MULTIPLE_FILE') {
      if (index != undefined) {
        field.index = index;
      }
      if (field.name == 'idProofFront' || field.name == 'idProofBack') {
        this.form?.get('identityDetails')?.get('sendForVerification')?.setValue(true);
        this.form
          ?.get('identityDetails')
          ?.get('idVerificationStatus')
          ?.setValue(IdVerificationStatusUiEnum.NOT_VERIFIED);
      }
      this.selectionImage(field, $event);
    } else {
      if (field.name == 'idType') {
        this.form?.get('identityDetails')?.get('sendForVerification')?.setValue(true);
        this.form
          ?.get('identityDetails')
          ?.get('idVerificationStatus')
          ?.setValue(IdVerificationStatusUiEnum.NOT_VERIFIED);
      }
      if (field.type == FieldTypeEnumSimplified.COUNTRY_CODE) {
        this.form?.get(field.name)?.setErrors(null);
        this.form?.get(field.name)?.clearValidators();
        this.form?.get(field.name)?.updateValueAndValidity();
      }
      this.selectionChange.emit({ field, $event });
    }
  }

  selectionImage(field: any, $event: any) {
    if ($event.target.files && $event.target.files[0]) {
      const maxSizeKB = 500;
      if ($event.target.files[0].size > maxSizeKB * 1024) {
        this.showImageError = field.name;
        throw new Error('<show error> File size exceeds 500 KB limit.');
      } else {
        this.showImageError = '';
        this.selectionChange.emit({ field, $event });
      }

      var reader = new FileReader();
      reader.readAsDataURL($event.target.files[0]);
      reader.onload = (event) => {
        let control = this.findFormControl(field.name);
        control.patchValue(event.target.result);
        field.value = event.target.result;
      };
    }
  }

  selectionImageByDragAndDrop(field: any, $event: any) {
    if ($event.dataTransfer.files && $event.dataTransfer.files[0]) {
      const maxSizeKB = 500;
      if ($event.dataTransfer.files[0].size > maxSizeKB * 1024) {
        this.showImageError = field.name;
        throw new Error('<show error> File size exceeds 500 KB limit.');
      } else {
        this.showImageError = '';
        this.selectionChange.emit({ field, $event, type: 'dragAndDrop' });
      }

      var reader = new FileReader();
      reader.readAsDataURL($event.dataTransfer.files[0]);
      reader.onload = (event) => {
        let control = this.findFormControl(field.name);
        control.patchValue(event.target.result);
        field.value = event.target.result;
      };
    }
  }

  scrollToFirstError() {
    const firstInvalidControl = document.querySelector('input.ng-invalid');
    if (firstInvalidControl) {
      const parentWithScrollbar = this.findParentWithScrollbar(firstInvalidControl);

      if (parentWithScrollbar) {
        const firstInvalidControlRect = firstInvalidControl.getBoundingClientRect();
        const parentRect = parentWithScrollbar.getBoundingClientRect();
        const offsetTop =
          firstInvalidControlRect.top - parentRect.top + parentWithScrollbar.scrollTop;

        parentWithScrollbar.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      }
    }
  }

  findParentWithScrollbar(element: any) {
    while (element.parentElement) {
      const style = getComputedStyle(element.parentElement);
      if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
        return element.parentElement;
      }
      element = element.parentElement;
    }
    return null;
  }

  status() {
    return this.form;
  }

  findFormControl(fieldName: string, obj: any = this.form.value): FormControl | null {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (key === fieldName) {
          return new FormControl(value);
        } else if (typeof value === 'object' && value !== null) {
          const foundControl = this.findFormControl(fieldName, value);
          if (foundControl) {
            return foundControl;
          }
        }
      }
    }
    return null;
  }

  getData(field: any) {
    if (this.findFormControl(field.name)?.value) {
      return this.findFormControl(field.name)?.value;
    } else {
      return field.imagePlaceHolder;
    }
  }

  getDataArray(field: any) {
    if (this.findFormControl(field.name)?.value) {
      return this.findFormControl(field.name)?.value;
    } else {
      return field.imagePlaceHolder;
    }
  }

  closeModal(field: any, event: any, value: boolean, isTime: boolean = false) {
    const currentFormValue = this.form?.get(field.name)?.value;
    this.closeCalenderEvent.emit([field, event, value, isTime, currentFormValue]);
    if (field.name == 'dateOfIssue' || field.name == 'validUntil') {
      this.form?.get('identityDetails')?.get('sendForVerification')?.setValue(true);
      this.form
        ?.get('identityDetails')
        ?.get('idVerificationStatus')
        ?.setValue(IdVerificationStatusUiEnum.NOT_VERIFIED);
    }
  }

  searchEventHandle(event: Event) {
    this.searchValue = (event.target as HTMLInputElement).value;
  }

  searchCountryEventHandle(event: Event) {
    this.searchCountryValue = (event.target as HTMLInputElement).value;
  }

  focusOnSelect() {
    document.getElementById('searchInput').focus();
  }

  displayNameAutoComplete(data: any) {
    return data?.key;
  }

  checkIfRangeSelected(fieldName: string, parentField: string) {
    if (!this.form?.get(parentField)?.get(fieldName)?.value) {
      this.form?.get(parentField)?.get(fieldName)?.setErrors({ required: true });
    } else {
      this.form?.get(parentField)?.get(fieldName)?.setErrors(null);
      this.form?.get(parentField)?.get(fieldName)?.clearValidators();
      this.form?.get(parentField)?.get(fieldName)?.updateValueAndValidity();
    }
  }

  getFrImageSource(field: any, index: number) {
    return !field?.value
      ? this.getDataArray(field)[index]?.signedURL
      : field?.value[index]?.signedURL;
  }

  removeFrImage(i: number) {
    this.removeFrImageEvent.emit(i);
  }

  openImage(imgSrc: string | S3ObjectUiPb) {
    let data = {
      imageSrc: imgSrc,
    };
    this.dialogControlService.openImage(data);
  }

  toggleSection(event: MatSlideToggleChange, section: FormDataSimplified) {
    this.isIdentityEnabled = event.checked;
    section.fields.forEach((element) => {
      if (event.checked) {
        this.form?.get(section.sectionFromGroup)?.get(element.name)?.enable();
      } else {
        if (element.name != 'idProofFront' && element.name != 'idProofBack') {
          this.form?.get(section.sectionFromGroup)?.get(element.name)?.disable();
        }
      }
    });
  }

  convertEnumForList() {
    let countryList: any = CountryUiEnum;
    this.nations = this.objectUtils.convertEnumForList(countryList);
  }

  removeLiteralNewlines(event: Event, field: fieldSimplified): void {
    const textarea = event.target as HTMLTextAreaElement;
    let newValue = textarea.value.replaceAll(/\\n/g, '');
    newValue = textarea.value.replaceAll(/\n/g, '');
    this.findFormControl(field.name).setValue(newValue);
  }

  removeNewLinesOnPaste(event: any): void {
    let clipboardData = event.clipboardData;
    let pastedData = clipboardData.getData('Text');
    var match = /\r|\n/.exec(pastedData);
    if (match) {
      event.preventDefault();
    }
  }

  onKeydown(event: any) {
    event.preventDefault();
  }

  getDynamicHeight(options: any[], maxHeight: number = 200, itemHeight: number = 30): number {
    if (!options || options.length === 0) {
      return 0;
    }
    const calculatedHeight = options.length * itemHeight;
    return Math.min(calculatedHeight, maxHeight);
  }

  onAutocompleteDropdownOpened() {
    this.virtualScroll.checkViewportSize();
  }

  onSearchChange() {
    if (this.virtualScroll) {
      this.virtualScroll.scrollToIndex(0);
    }
  }

  removeFormArrayItem(field: fieldSimplified, sectionIndex?: number, formArrayIndex?: number) {
    let eventData: FieldSimplifiedWithSectionIndex = { field, sectionIndex, formArrayIndex };
    this.clickEvent.emit(eventData);
  }
  trackByIndex(index: number): number {
    console.log(index);
    return index;
  }

  getFormArray(arrayName: string): FormArray {
    if (!arrayName) {
      console.warn('No array name provided');
      return new FormArray([]);
    }

    if (!this.form) {
      console.warn('Form not initialized');
      return new FormArray([]);
    }
    const array = this.form.get(arrayName) as FormArray;

    if (!array) {
      console.warn(`FormArray '${arrayName}' not found in form`);
      return new FormArray([]);
    }
    return array;
  }
}
